import * as Yup from 'yup';
import { EmailAddress, Uuid } from 'ValueObjects';

export interface CreateOrganizationInputType {
  organizationName: string;
  organizationCode: string;
  address: {
    street?: string;
    houseNumberWithAddition?: string;
    city?: string;
    postalCode?: string;
    country?: string;
  };
  vatNumber?: string;
  invoiceContactName?: string;
  reference?: string;
  invoiceEmailAddress?: EmailAddress;
  reseller?: { organizationId?: Uuid } | null;
}

export const CreateOrganizationInputTypeValidationBuilder =
  (): Yup.SchemaOf<CreateOrganizationInputType> =>
    Yup.object({
      organizationName: Yup.string().required().label('label.organizationName'),
      organizationCode: Yup.string().required().label('label.organizationCode'),
      vatNumber: Yup.string().label('label.vatNumber'),
      invoiceContactName: Yup.string().label('label.invoiceContactName'),
      reference: Yup.string().label('label.reference'),
      invoiceEmailAddress: Yup.string().email().label('label.reference'),
      reseller: Yup.object({
        organizationId: Yup.string().required().label('label.organization'),
      }),
      address: Yup.object({
        street: Yup.string().ensure().label('label.street'),
        houseNumberWithAddition: Yup.string()

          .ensure()
          .label('label.houseNumberWithAddition'),
        city: Yup.string().ensure().label('label.city'),
        postalCode: Yup.string().ensure().label('label.postalCode'),
        country: Yup.string().ensure().label('label.country'),
      }),
    });

export const CreateOrganizationInputTypeDefaultValues =
  (): CreateOrganizationInputType => ({
    organizationName: '',
    organizationCode: '',
    vatNumber: '',
    invoiceContactName: '',
    invoiceEmailAddress: '',
    reference: '',
    reseller: null,
    address: {
      street: '',
      houseNumberWithAddition: '',
      city: '',
      postalCode: '',
      country: '',
    },
  });
